import { useMemo, useRef, useState } from "react";
import Input from "@Components/Input";
import styles from "../../../LeadFormModal/LeadFormModal.module.scss";
import { getApartmentConfigurationOptions } from "@Components/LeadForm/utils";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import DropdownIcon from "@Icons/DropdownIcon";
import useClickOutside from "hooks/useOutsideClick";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

const RoomTypeDropdown = ({
  error,
  setErrors,
  selectedRoom,
  setSelectedRoom,
  testIdPrefix,
}: any) => {
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const ref = useRef(null);

  const handleSelectRoom = (room: any) => {
    setSelectedRoom(room.value);
    setErrors((errors: any) => ({ ...errors, room: "" }));
    setShowOptions(false);
  };

  const { t } = useTranslationHook();

  const { inventory } = useSelector(
    ({ leadFormModal }: AppState) => ({
      inventory: leadFormModal.inventory,
    }),
    shallowEqual,
  );
  const countryShortName = inventory?.location?.country?.short_name;

  const country = useMemo(() => {
    const fullLocation = countryShortName || "";
    switch (fullLocation) {
      case "AU":
        return "australia";
      case "US":
        return "us";
      case "IE":
        return "ireland";
      case "ES":
        return "spain";
      case "CA":
        return "canada";
      default:
        return "uk";
    }
  }, [countryShortName]);

  useClickOutside(ref, () => setShowOptions(false));

  return (
    <div className={styles.universityDropdownContainer} ref={ref}>
      <Input
        type="dropdown"
        label={t("Room Type")}
        placeholder={t("Select Room type")}
        value={selectedRoom}
        onFocus={() => setShowOptions(true)}
        clearable
        handleClear={() => {
          setSelectedRoom("");
          setShowOptions(false);
        }}
        rightIcon={!selectedRoom && <DropdownIcon size={15} />}
        rightIconClassName={error ? styles.rightIconWithError : ""}
        showErrorMessage={Boolean(error)}
        error={error}
        dataTestId={`${testIdPrefix}leadform-input-roomType`}
        required
        id="roomAccomodation"
      />
      {showOptions && (
        <div
          className={styles.universityDropdownOptContainer}
          data-testid={`${testIdPrefix}leadform-dropdown-option-container`}
        >
          {getApartmentConfigurationOptions(country).map((room: any) => (
            <div
              key={room.label}
              className={formatClassNames(
                styles.option,
                room.label === selectedRoom ? styles.selected : "",
              )}
              onClick={() => handleSelectRoom(room)}
              data-testid={`${testIdPrefix}leadform-roomTypes`}
              role="none"
            >
              <div>{room.label}</div>
              <div className={styles.optionDesc}>{room.description}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default wrapperHOC(RoomTypeDropdown, {
  componentName: "RoomTypeDropdown-dropdown-LeadForm-Global",
  showForChina: true,
});
